var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_3002",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0312 11.7967H24.125V11.75H14V16.25H20.3579C19.4304 18.8696 16.9379 20.75 14 20.75C10.2723 20.75 7.25 17.7277 7.25 14C7.25 10.2723 10.2723 7.25 14 7.25C15.7207 7.25 17.2861 7.89913 18.4781 8.95944L21.6601 5.77737C19.6509 3.90481 16.9633 2.75 14 2.75C7.78719 2.75 2.75 7.78719 2.75 14C2.75 20.2128 7.78719 25.25 14 25.25C20.2128 25.25 25.25 20.2128 25.25 14C25.25 13.2457 25.1724 12.5094 25.0312 11.7967Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04712 8.76369L7.74331 11.4744C8.74343 8.99825 11.1656 7.25 14 7.25C15.7207 7.25 17.2861 7.89913 18.4781 8.95944L21.6601 5.77737C19.6509 3.90481 16.9632 2.75 14 2.75C9.67887 2.75 5.93149 5.18956 4.04712 8.76369Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 25.2504C16.9057 25.2504 19.5461 24.1383 21.5424 22.3299L18.0605 19.3835C16.931 20.2391 15.527 20.7504 13.9998 20.7504C11.0737 20.7504 8.58912 18.8846 7.65312 16.2808L3.9845 19.1073C5.84637 22.7506 9.6275 25.2504 13.9998 25.2504Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0312 11.7967H24.125V11.75H14V16.25H20.3579C19.9124 17.5083 19.103 18.5934 18.059 19.3837C18.0596 19.3831 18.0601 19.3831 18.0607 19.3826L21.5426 22.3289C21.2962 22.5528 25.25 19.625 25.25 14C25.25 13.2457 25.1724 12.5094 25.0312 11.7967Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.ab304ef841d733f879de4a76897c660d.svg";
export { ForwardRef as ReactComponent };